// @ts-check
/**
 * @file managerAttention.js
 * @location src/utils/managerAttention.js
 * @role 매니저 업무탭 주목 칩 필터 — 안 읽음/기한 초과 2종. (검수·진척정체 버킷은 razor ㉓ 폐기)
 *
 * razor ④ 정합: 수치 지표가 아니라 「주의가 필요한 항목」의 액션 라우팅.
 */
import { isClosed } from '../data/labels.js';
import { isOverdue, getTodayStr } from './dateUtils.js';

/** 업무탭 주목 칩 키 순서 (예정는 칩이 아니라 하단 섹션 — 칩은 안 읽음/기한 초과 둘) */
export const ATTENTION_KEYS = ['unack', 'overdue'];

/** 버킷 라벨 — 주목 칩 + 예정 섹션 헤더 단일 소스 */
export const ATTENTION_LABELS = {
  unack: '안 읽음',
  overdue: '기한 초과',
  future: '예정',
};

/**
 * 가시 task 에서 버킷 산출. 버킷 간 중복 허용(글랜스 용).
 *   unack=안 읽음 / overdue=기한 초과 / future=예정(미래 지정일 — 그날까지 도래 전, 하단 섹션용)
 * 예정 = 지정(dateKind==='ondate') 이면서 due 가 오늘보다 미래인 것. 기한(까지)은 기간 내내 보여야 하므로 제외.
 * @param {import('../data/types.js').Task[]} tasks  가시성 필터된 task 배열
 * @param {string} [_uid]  매니저 uid (현재 미사용 — 시그니처 호환 유지)
 * @param {string} [todayStr] 기준 오늘(YYYY-MM-DD). 미지정 시 시스템 시각. 테스트의 시간 의존성 격리용
 * @returns {{ unack: import('../data/types.js').Task[], overdue: import('../data/types.js').Task[], future: import('../data/types.js').Task[] }}
 */
export function getAttentionBuckets(tasks, _uid, todayStr) {
  const today = todayStr ?? getTodayStr();
  const unack = [];
  const overdue = [];
  const future = [];
  for (const t of tasks) {
    if (isClosed(t.status)) continue;
    if (!t.acknowledgedAt) unack.push(t);            // 안 읽음 — 아직 안 열어봄
    if (isOverdue(t.due, t.status)) overdue.push(t);  // 기한 초과
    if (t.dateKind === 'ondate' && t.due && t.due > today) future.push(t); // 예정 — 미래 지정일
  }
  return { unack, overdue, future };
}
